/*
 * config: { ignoreError: true },
 * config: { returnRes: true },
 * */
import * as httpUtil from "@/utils/httpUtil";

import { post } from "@utils/httpUtil";

//获取结算列表
export function expressFeeRuleFindNameList(data: Record<string | number, any>, config?: Record<string | number, any>) {
  return post(`${process.env.VUE_APP_OPEN_WENWO_LINK}/middle-sp/settlement/expressFeeRule/findNameList`, data, config);
}

const interfaces: Array<Record<string, any>> = [
  {
    method: "post",
    name: "getGoodsCatalogTree",
    url: "/c/pc/deliver/drug/background/tree",
    desc: "商品后台类目",
  },
  {
    method: "post",
    name: "applySettle",
    url: "/c/pc/community/supplier/settled/applySettle",
    desc: "社区申请零售商入驻",
  },
  {
    method: "post",
    name: "findSupplier",
    url: "/c/pc/community/supplier/settled/findSupplier",
    desc: "查询社区供应商信息",
  },
  {
    method: "post",
    name: "goodsAuditRecord",
    url: "/c/pc/community/goods/supplier/auditRecordPageList",
    desc: "查询零售商商品审核记录（审核通过/审核拒绝）",
  },
  {
    method: "post",
    name: "auditPageList",
    url: "/c/pc/community/goods/supplier/auditPageList",
    desc: "查询商家商品审核列表（审核中）",
  },
  {
    method: "post",
    name: "findBasicGoodsAuditSnapshot",
    url: "/c/pc/community/goods/supplier/findBasicGoodsAuditSnapshot",
    desc: "查询商家商品快照数据",
  },
  {
    method: "post",
    name: "goodsAddOrUpdate",
    url: "/c/pc/community/goods/supplier/detail/edit",
    desc: "查询零售商商品申请入库页面详情（新增和编辑都调用这个接口获取详情）",
  },
  {
    method: "post",
    name: "goodsPageList",
    url: "/c/pc/community/goods/supplier/pageList",
    desc: "分页查询零售商商品管理列表",
  },
  {
    method: "post",
    name: "saveOrUpdate",
    url: "/c/pc/community/goods/supplier/saveOrUpdate",
    desc: "零售商商品申请入库（新增或编辑）",
  },
  {
    method: "post",
    name: "editPreCheck",
    url: "/c/pc/community/goods/supplier/editPreCheck",
    desc: "基础商品编辑前置校验",
  },
  {
    method: "post",
    name: "batchStockOut",
    url: "/c/pc/community/goods/trace/order/batchStockOut",
    desc: "出库/批量出库",
  },
  {
    method: "post",
    name: "cancelOrder",
    url: "/c/pc/community/goods/trace/order/cancel",
    desc: "取消订单",
  },
  {
    method: "post",
    name: "orderDeliver",
    url: "/c/pc/community/goods/trace/order/deliver",
    desc: "发货",
  },
  {
    method: "postExFile",
    name: "exportBatchDeliverFailList",
    url: "/c/pc/community/goods/trace/order/exportBatchDeliverFailList",
    desc: "导出批量发货失败列表",
  },
  {
    method: "postExFile",
    name: "exportWaitDeliver",
    url: "/c/pc/community/goods/trace/order/exportWaitDeliver",
    desc: "导出全部已出库未发货订单",
  },
  {
    method: "post",
    name: "goodsOrderDetailById",
    url: "/c/pc/community/goods/trace/order/findById",
    desc: "根据id查询履约单详情",
  },
  {
    method: "postFile",
    name: "importAndBatchDeliver",
    url: "/c/pc/community/goods/trace/order/importAndBatchDeliver",
    desc: "导入并批量发货",
  },
  {
    method: "post",
    name: "goodsOrderPageList",
    url: "/c/pc/community/goods/trace/order/pageList",
    desc: "分页查询履约单列表",
  },
  {
    method: "post",
    name: "createGoodsOrder",
    url: "/c/pc/community/goods/trace/order/save",
    desc: "创建履约单",
  },
  {
    method: "post",
    name: "updateLogistics",
    url: "/c/pc/community/goods/trace/order/updateLogistics",
    desc: "修改发货信息",
  },
  {
    method: "get",
    name: "getExpressData",
    url: "/c/pc/express/getExpressData",
    desc: "查询物流详情",
  },
  {
    method: "post",
    name: "expressCompanyList",
    url: "/c/pc/express/expressCompanyList",
    desc: "快递公司列表",
  },

  {
    method: "post",
    name: "storePageList",
    url: "/c/pc/community/goods/supplier/storePageList",
    desc: "供应商品库列表",
  },
  {
    method: "post",
    name: "findBasicGoodsStatistics",
    url: "/c/pc/community/goods/supplier/findBasicGoodsStatistics",
    desc: "查询供应商（商家）数据统计",
  },
  {
    method: "post",
    name: "updateBasicGoodsAuditRecordReadStatus",
    url: "/c/pc/community/goods/supplier/updateBasicGoodsAuditRecordReadStatus",
    desc: "更新基础商品审核记录阅读状态",
  },
  {
    method: "post",
    name: "updateIzDel",
    url: "/c/pc/community/goods/supplier/updateIzDel",
    desc: "基础商品上下架",
  },
  {
    method: "post",
    name: "updateStock",
    url: "/c/pc/community/goods/supplier/updateStock",
    desc: "基础商品修改库存",
  },
  // 商品合集
  {
    method: "post",
    name: "collectionSave",
    url: "/c/pc/goods/collection/save",
    desc: "商品合集保存",
  },
  {
    method: "post",
    name: "collectionFindById",
    url: "/c/pc/goods/collection/findById",
    desc: "商品合集保存",
  },
  {
    method: "post",
    name: "getCommunityList",
    url: "/c/pc/community/pageCommunities",
    desc: "分页查询社区列表",
  },
  {
    method: "post",
    name: "getDefaultExpressFeeRuleId",
    url: "/c/pc/community/goods/supplier/getDefaultExpressFeeRuleId",
    desc: "获取默认快递规则ID",
  },
  {
    method: "postExFile",
    name: "exportStorePageListExcel",
    url: "/c/pc/community/goods/supplier/batchUpdatePrice/exportStorePageListExcel",
    desc: "导出数据",
  },
  {
    method: "postFile",
    name: "importExcelAndRead",
    url: "/c/pc/community/goods/supplier/batchUpdatePrice/importExcelAndRead",
    desc: "导入excel获取行数和数据",
  },
  {
    method: "post",
    name: "batchUpdatePrice",
    url: "/c/pc/community/goods/supplier/batchUpdatePrice",
    desc: "批量修改价格",
  },
];

function exportsRender(interfacesArr: Array<Record<string, any>>) {
  const resultExports: Record<string, any> = {};
  interfacesArr.map((item: Record<string, any>) => {
    resultExports[item.name] = (data: Record<string | number, any>) => {
      return (httpUtil as Record<string, any>)[item.method](item.url, data, item.config);
    };
  });
  return resultExports;
}

export default exportsRender(interfaces);
